<template>
  <transition name="fade">
    <div 
      v-if="visible"
      :class="['toast', `toast--${type}`]"
      @click="hide"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: '',
      type: 'info',
      duration: 3000,
      timer: null
    }
  },
  methods: {
    show(message, type = 'info', duration = 3000) {
      this.message = message
      this.type = type
      this.duration = duration
      this.visible = true

      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.hide()
      }, this.duration)
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  background: #323232;
  color: white;
  border-radius: 4px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  max-width: 80%;
  word-break: break-word;
  backdrop-filter: blur(10px);
}

.toast--success { background: #4CAF50; }
.toast--error { background: #F44336; }
.toast--warning { background: #FF9800; }
.toast--info { background: rgba(0,0,0,0.7); }

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

/* 手机端强制横屏 */
@media screen and (orientation:portrait) {
	.toast{
		/* top: 40%;
		left: 5%;
		transform: translateX(-5%); */
		transform-origin: 0 0;
		transform: rotateZ(90deg) translateY(-100%);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Toast.vue